import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import Version from '../../version'

export default function NotFoundPage() {
    const { t } = useTranslation()

    return (
        <Container className='my-5'>
            <Row>
                <Col className='text-center'>
                    <h1 className='fw-bold' style={{ fontSize: '6rem', color: '#EF0000' }}>404</h1>
                    <h3 className='fw-bold mb-3'>{t('global.pagenotfound')}</h3>
                    <p className='text-muted mb-4'>{t('global.error404description')}</p>
                    <a href='/teacher/dashboard' className='btn btn-primary'>{t('global.return')}</a>
                </Col>
            </Row>
        </Container>
    )
}
